const weatherKeyToIconMapping: any = {
  Sunny: "Sunny Weather Icon",
  PartlyCloudy: "Part Cloud Weather Icon",
  Cloudy: "Cloudy Weather Icon",
  LightRain: "Light Rain Icon",
  HeavyRain: "Heavy Rain Icon",
  Stormy: "Stormy Icon",
  Windy: "Windy Icon",
  Sleet: "Sleet Icon",
  LightSnow: "Light Snow Icon",
  HeavySnow: "Heavy Snow Icon",
  VeryHot: "V Hot Icon",
  VeryCold: "V Cold Icon"
};

const mapWeatherKeyToIconName = (weatherKey: string): string => {
  let iconName;
  try {
    iconName = weatherKeyToIconMapping[weatherKey];
  } catch (Excepion) {
    // ignore
  }
  return iconName;
};

export { weatherKeyToIconMapping, mapWeatherKeyToIconName };
